
export enum EventName {
  SubscriptionProductAbout = 'subscription_product_about',
  SubscriptionProductBuy = 'subscription_product_buy',
  SubscriptionProductResume = 'subscription_product_resume'
}

interface IEvent<TType extends EventName> {
  event: TType;
  userId?: string;
  passportId?: string;
  projectId?: string;
  fork_id?: string;
  platform?: string;
}

interface IEventProperties {
  user_id: string;
  product_id: string;
}

interface ISubscriptionProductAbout extends IEvent<EventName.SubscriptionProductAbout>, IEventProperties {}

interface ISubscriptionProductBuy extends IEvent<EventName.SubscriptionProductBuy>, IEventProperties {}

interface ISubscriptionProductResume extends IEvent<EventName.SubscriptionProductResume>, IEventProperties {}

export type IEventUnion = ISubscriptionProductAbout | ISubscriptionProductBuy | ISubscriptionProductResume;